const API_BASE = process.env.REACT_APP_API_URL || '/api';

const getToken = () => localStorage.getItem('supertask_token');

const apiFetch = async (path, options = {}) => {
  const token = getToken();
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...options.headers,
    },
    body: options.body ? JSON.stringify(options.body) : undefined,
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || err.message || res.statusText);
  }
  if (res.status === 204) return null;
  return res.json();
};

export default apiFetch;

// Legacy export for components that import { supabase }
// This is a stub to prevent import errors during migration
export const supabase = null;
